import { useMutation, useQuery } from '@tanstack/react-query'
import * as requests from './requests'
import { TNpsFirstAnswerPayload, TNpsSubmitPayload } from './types'

export const KEY_GET_NPS_FORM = 'getNpsForm'

export const useGetNpsForm = (token: string, enabled = true) =>
  useQuery({
    queryKey: [KEY_GET_NPS_FORM, token],
    queryFn: () => requests.getNpsForm(token),
    enabled: Boolean(token) && enabled,
    retry: false,
    staleTime: 0,
    refetchOnWindowFocus: false
  })

export const useSendNpsFirstAnswer = (token: string) =>
  useMutation({
    mutationFn: (payload: TNpsFirstAnswerPayload) => requests.sendNpsFirstAnswer(token, payload)
  })

export const useSubmitNpsForm = (token: string) =>
  useMutation({
    mutationFn: (payload: TNpsSubmitPayload) => requests.submitNpsForm(token, payload)
  })
